export enum PrivacyConsentSource {
    AGREE = "AGREE",
    WITHDRAW = "WITHDRAW"
}